import React, { Component } from "react";
import { Navigate } from "react-router-dom";

// reactstrap components
import {
    Card,
    CardTitle,
    CardHeader,
    CardBody,
    Row,
    Col,
    Table,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import axios from "axios";
import { api_link } from "siteConfig";

class JobList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            setFilter: this.props.filter,
            Jobs: [],
            selectedSite: null,
            selectedJob: null,
            navigate: false,
            searchTerm: ''
        };
    }

    componentDidMount() {
        // console.log("JobList mounted");
        this.loadSiteJobs();
    }

    loadSiteJobsData = async (site_ids) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getJobs';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": site_ids,
                    "status": this.props.filter
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadSiteJobs = async () => {
        const siteIds = sessionStorage.getItem("site_ids");
        const JobsData = await this.loadSiteJobsData(siteIds);
        this.setState({ Jobs: JobsData });
    }

    handleJobRowClick = (site_id, jobId) => {
        // console.log("Job Row Clicked", site_id, jobId);
        sessionStorage.setItem("target_site_id", site_id);
        sessionStorage.setItem("target_job_id", jobId);
        this.setState({ navigate: true });
    }

    render() {

        if (this.state.navigate) {
            return <Navigate to={"/admin/sitesearch"} />;
        }

        return (
            <>
                <PanelHeader
                    size="lg"
                    content={image}
                />
                <div className="content" style={{ marginTop: '-270px' }}>
                    <Row>
                        <Col xs={12} md={12}>
                            <Card className="card-chart">
                                <CardHeader>
                                    <CardTitle tag="h4">{sessionStorage.getItem("customer_name")} Job List <sup><small>{this.props.filter.toUpperCase()}</small></sup></CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <InputGroup className="no-border">
                                        <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.setState({ searchTerm: e.target.value })} />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>
                                                <i className="now-ui-icons ui-1_zoom-bold" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {this.state.Jobs.length > 0 ? (
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td>Job Number</td>
                                                    <td>Site</td>
                                                    <td>Order Number</td>
                                                    <td>Authority</td>
                                                    <td>Description</td>
                                                    <td>Status</td>
                                                    <td>Logged Date</td>
                                                    <td>Last Visit</td>
                                                    <td>Completed</td>
                                                </tr>
                                                {this.state.Jobs
                                                .filter((job) =>
                                                    ((job.Name &&job.Name.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                    || (job.ToDo && job.ToDo.toLowerCase().includes(this.state.searchTerm.toLowerCase()) )
                                                    || (job.JobID && job.JobID.toString().includes(this.state.searchTerm)  )
                                                    || (job.Reference && job.Reference.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                    || (job.Authority && job.Authority.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                )
                                                )
                                                .map((job) => (
                                                    <tr onClick={() => this.handleJobRowClick(job.SiteID,job.JobID)} key={job.JobID}>
                                                        <td>{job.JobID}</td>
                                                        <td>{job.Name}</td>
                                                        <td>{job.Reference}</td>
                                                        <td>{job.Authority}</td>
                                                        <td>{job.ToDo && job.ToDo.substr(0, 50)}</td>
                                                        <td>{job.Status}</td>
                                                        <td>{job.Logged ? new Date(job.Logged).toLocaleDateString("en-GB") : ""}</td>
                                                        <td>{job.LastVisit ? new Date(job.LastVisit).toLocaleDateString("en-GB") : ""}</td>
                                                        <td>{job.Completed ? new Date(job.Completed).toLocaleDateString("en-GB") : ""}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <p>NO RESULTS</p>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default JobList;